export const mask = (v) => {
  v = v.replace(/\D+/g, ""); // não deixa ser digitado nenhuma letra

  return v;
};
